import { NotificationTypeId } from '../types';

interface NotificationState {
    micMuted: boolean;
    cameraMutedForNotification: boolean;
    reactionType: string | null | undefined;
    waitingRoomEmpty: boolean;
    summarizationRunning: boolean;
    recordingActive: boolean;
}

/**
 * Вычисляет активные типы нотификаций на основе состояния.
 *
 * Логика объединения: если mic И camera muted -> только 'mute-both'.
 * Примечание: cameraMutedForNotification должен учитывать canToggleVideo (roomAgent v2).
 */
export function getActiveNotificationTypes(notificationState: NotificationState): NotificationTypeId[] {
    const {
        micMuted,
        cameraMutedForNotification,
        reactionType,
        waitingRoomEmpty,
        summarizationRunning,
        recordingActive,
    } = notificationState;

    const types: NotificationTypeId[] = [];

    // Primary row: mute нотификации (с объединением)
    if (micMuted && cameraMutedForNotification) {
        types.push('mute-both');
    } else if (micMuted) {
        types.push('mute-microphone');
    } else if (cameraMutedForNotification) {
        types.push('mute-camera');
    }

    // Primary row: рука
    if (reactionType === 'hand') {
        types.push('reaction-hand');
    }

    // Secondary row: info-нотификации
    if (!waitingRoomEmpty) {
        types.push('waiting-room');
    }
    if (summarizationRunning) {
        types.push('summarization');
    }
    if (recordingActive) {
        types.push('recording');
    }

    return types;
}
